import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";

// Coming Soon: these are gated behind ComingSoon for now. Re-enable the import
// and swap the routes back when Mobile Wallet / Cards / Invoices ship.
// import Wallet from "./pages/Wallet";

import Dashboard from "./pages/Dashboard";
import AddFunds from "./pages/AddFunds";
import AddRecipient from "./Components/recipients/AddRecipient";
import Recipient from "./Components/recipients/Recipient";
import QrPayment from "./pages/QrPayment";
// import Card from "./pages/Card";
// import CreateNewCard from "./Components/cards/CreateNewCard";
import NewConversion from "./Components/convert/NewConversion";
// import CreateCompanyCard from "./Components/cards/CreateCompanyCard";
// import CreateCompanyCard2 from "./Components/cards/CreateCompanyCard2";
// import SummaryDetailsCards from "./Components/cards/SummaryDetailsCards";
import ScheduleYourTransfer from "./Components/schedule-transfer/ScheduleYourTransfer";

import { NewTransfer } from "./Components";
import ReviewScheduleTransfer from "./Components/schedule-transfer/ReviewScheduleTransfer";
import RequestMoney from "./Components/request-money/RequestMoney";
import RequestMoneySummary from "./Components/request-money/RequestMoneySummary";
// import Invoice from "./Components/invoice-generator/Invoice";
// import InvoiceCreated from "./Components/invoice-generator/InvoiceCreated";
import ComingSoon from "./pages/ComingSoon";
import Statement from "./Components/statement/Statement";
import InvitePeople from "./Components/invite-people/InvitePeople";
import ConnectNewAccount from "./Components/my-accounts/ConnectNewAccount";
import MyAccounts from "./Components/my-accounts/MyAccounts";
import BudgetReport from "./Components/manage-spending/BudgetReport";
import SpendingReport from "./Components/manage-spending/SpendingReport";
import MyBills from "./Components/manage-spending/my-bills/MyBills";
import AddBillers from "./Components/manage-spending/my-bills/AddBillers";
import Billers from "./Components/manage-spending/my-bills/Billers";
import CalendarView from "./Components/manage-spending/my-bills/CalendarView";
import MyTransaction from "./Components/my-transactions/MyTransaction";
import BudgetTracker from "./Components/manage-spending/budget/BudgetTracker";
import BudgetSetup from "./Components/manage-spending/budget/BudgetSetup";
import CreateBudget from "./Components/manage-spending/budget/CreateBudget";
import RetirementPlan from "./Components/plan-for-retirement/RetirementPlan";
import SaveAndInvest from "./Components/save-and-invest/SaveAndInvest";
import Credit from "./Components/credit/Credit";
import Overview from "./Components/overview/Overview";
import OverviewDetail from "./Components/overview/OverviewDetail";
import SplitPayment from "./Components/spilt-payment/SplitPayment";
import Reminder from "./Components/spilt-payment/Reminder";
import SettleUp from "./Components/spilt-payment/SettleUp";
import CreateGroup from "./Components/spilt-payment/CreateGroup";
import AddExpenses from "./Components/spilt-payment/AddExpenses";
import ViewByPerson from "./Components/spilt-payment/ViewByPerson";
import SplitSummary from "./Components/spilt-payment/SplitSummary";
import PendingTransactions from "./pages/PendingTransactions";
import Reports from "./pages/Reports";
import IncomeExpenseCalendar from "./Components/manage-spending/IncomeExpenseCalendar";

import LoginSuccess from "./pages/Auth/LoginSuccess";
import Login from "./pages/Login";
import RequireAuth from "./Components/auth/RequireAuth";
import AdminPanel from "./pages/AdminPanel";
import AdminTransactionHistory from "./pages/AdminTransactionHistory";
import AdminSettings from "./pages/AdminSettings";
import Settings from "./pages/Settings";
import HelpCenter from "./pages/HelpCenter";
import NotFound from "./pages/NotFound";
import {
  FIGMA_FLOW_ROUTES,
  FigmaScreenRoute,
  FigmaScreensIndex,
} from "./pages/FigmaScreens";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/loginsuccess" element={<LoginSuccess />} />
      <Route element={<RequireAuth />}>
        {/* Dashboard Route */}
        <Route path="/dashboard" element={<Dashboard />} />
        {/* Wallet Routes */}
        <Route path="/wallet" element={<ComingSoon feature="Mobile Wallet" navName="Mobile Wallet" />} />
        <Route path="/wallet/balance" element={<ComingSoon feature="Mobile Wallet" navName="Mobile Wallet" />} />
        <Route path="/wallet/balance-details" element={<ComingSoon feature="Mobile Wallet" navName="Mobile Wallet" />} />
        <Route path="/wallet/transaction" element={<ComingSoon feature="Mobile Wallet" navName="Mobile Wallet" />} />
        <Route path="/wallet/summary" element={<ComingSoon feature="Mobile Wallet" navName="Mobile Wallet" />} />
        <Route path="/wallet/account-activity" element={<ComingSoon feature="Mobile Wallet" navName="Mobile Wallet" />} />
        {/* Send-Money Routes */}
        <Route path="/new-transfer" element={<NewTransfer />} />
        <Route path="/new-transfer/existing-recipients" element={<NewTransfer initialTab="Existing Recipient" />} />
        <Route path="/new-transfer/existing-recipients/review" element={<FigmaScreenRoute screenSlug="send-money-existing-recipients-review" />} />
        <Route path="/new-transfer/someone-new/domestic" element={<NewTransfer initialTab="Someone New" someoneNewInitialTab="Domestic Transfer" />} />
        <Route path="/new-transfer/someone-new/domestic/review" element={<FigmaScreenRoute screenSlug="send-money-someone-new-domestic-transfer-review" />} />
        <Route path="/new-transfer/someone-new/international" element={<NewTransfer initialTab="Someone New" someoneNewInitialTab="International Transfer" />} />
        <Route path="/new-transfer/someone-new/international/recipient-info" element={<NewTransfer initialTab="Someone New" someoneNewInitialTab="International Transfer" />} />
        <Route path="/new-transfer/someone-new/international/review" element={<FigmaScreenRoute screenSlug="send-money-someone-new-international-transfer-review" />} />
        <Route path="/new-transfer/someone-new/bpay" element={<NewTransfer initialTab="Someone New" someoneNewInitialTab="Bill Payment" />} />
        <Route path="/new-transfer/someone-new/bpay/review" element={<FigmaScreenRoute screenSlug="send-money-someone-new-bpay-review" />} />

        {/*Card Routes (Coming Soon)  */}
        <Route path="/card" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/company" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/employee" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/settings" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/summary" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/summary/alternate" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/create" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/create-company" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/cards/create-company/employee" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/create-new-card" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/create-company-card" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/create-company-card2" element={<ComingSoon feature="Cards" navName="Card" />} />
        <Route path="/card-summary" element={<ComingSoon feature="Cards" navName="Card" />} />

        {/* Schedule Transfer */}
        <Route
          path="/schedule-transfer-review"
          element={<ReviewScheduleTransfer />}
        />
        <Route path="/schedule-transfer" element={<ScheduleYourTransfer />} />
        <Route path="/schedule-transfer/create" element={<ScheduleYourTransfer />} />
        <Route path="/schedule-transfer/details" element={<ScheduleYourTransfer />} />
        <Route path="/schedule-transfer/review" element={<ReviewScheduleTransfer />} />
        <Route path="/schedule-transfer/review/alternate" element={<ReviewScheduleTransfer />} />

        {/* Convert Routes */}
        <Route path="/convert" element={<NewConversion />} />
        <Route path="/convert/new-conversion" element={<NewConversion />} />
        {/* Add Funds Routes */}
        <Route path="/add-funds" element={<AddFunds />} />
        <Route path="/add-funds/banking-portal" element={<AddFunds initialTab="Bank Deposit" />} />
        <Route path="/add-funds/direct-debit" element={<AddFunds initialTab="Direct Debit" />} />

        {/* Recipient Route */}
        <Route path="/add-recipient" element={<AddRecipient />} />
        <Route path="/recipient" element={<Recipient />} />
        <Route path="/recipients/add" element={<AddRecipient />} />
        <Route path="/recipients" element={<Recipient />} />

        {/* Request Money */}
        <Route path="/request-money" element={<RequestMoney />} />
        <Route path="/request-money/create" element={<RequestMoney initialTab="Create" />} />
        <Route path="/request-money/details" element={<RequestMoney initialTab="Create" />} />
        <Route path="/request-money/review" element={<RequestMoneySummary />} />
        <Route path="/request-money/confirmation" element={<RequestMoneySummary />} />
        <Route
          path="/request-money-summary"
          element={<RequestMoneySummary />}
        />

        {/* QR Payment   */}
        <Route path="/qr-payment" element={<QrPayment />} />
        <Route path="/qr-payment/pay" element={<QrPayment initialTab="QR Pay" />} />
        <Route path="/qr-payment/receive" element={<QrPayment initialTab="QR Receive" />} />

        {/* Statement  */}
        <Route path="/statement" element={<Statement />} />
        <Route path="/statements" element={<Statement />} />

        {/* Invoice Created */}
        <Route path="/invoice-generator" element={<ComingSoon feature="Invoices" navName="Invoice" />} />
        <Route path="/invoice-flow/create" element={<ComingSoon feature="Invoices" navName="Invoice" />} />
        <Route path="/invoice-flow/review" element={<ComingSoon feature="Invoices" navName="Invoice" />} />
        <Route path="/invoice-flow/created" element={<ComingSoon feature="Invoices" navName="Invoice" />} />
        <Route path="/invoice-created" element={<ComingSoon feature="Invoices" navName="Invoice" />} />

        {/* Invite People */}
        <Route path="/invite-people" element={<InvitePeople />} />
        <Route path="/invite-people/referral-centre" element={<InvitePeople initialTab="Referral Center" />} />
        <Route path="/invite-people/my-invites" element={<InvitePeople initialTab="My Invites" />} />
        <Route path="/invite-people/my-invites/popup" element={<InvitePeople initialTab="My Invites" />} />

        {/* My Account */}
        <Route path="/connect-new-account" element={<ConnectNewAccount />} />
        <Route path="/my-account" element={<MyAccounts />} />
        <Route path="/my-accounts/connect-new-account" element={<ConnectNewAccount />} />
        <Route path="/my-accounts" element={<MyAccounts />} />

        {/* My Spending */}
        <Route path="/manage-spending" element={<BudgetReport />} />
        <Route path="/manage-spending/setup/popup" element={<BudgetSetup />} />
        <Route path="/manage-spending/budget-setup" element={<BudgetSetup />} />
        <Route path="/manage-spending/budget-setup/alternate" element={<BudgetSetup />} />
        <Route path="/manage-spending/budget-tracking" element={<BudgetTracker />} />
        <Route path="/manage-spending/create-budget" element={<CreateBudget />} />
        <Route path="/manage-spending/tags/popup" element={<BudgetSetup />} />
        <Route path="/manage-spending/spending-report" element={<SpendingReport />} />
        <Route path="/manage-spending/spending-report/alternate" element={<SpendingReport />} />
        <Route path="/budget-report" element={<BudgetReport />} />
        <Route path="/spending-report" element={<SpendingReport />} />
        <Route
          path="/income-expense-calendar"
          element={<IncomeExpenseCalendar />}
        />

        {/* My Bills */}
        <Route path="/my-bills" element={<MyBills />} />
        <Route path="/my-bills/overview" element={<MyBills />} />
        <Route path="/my-bills/create-transaction" element={<MyBills />} />
        <Route path="/my-bills/create-transaction/advanced" element={<MyBills />} />
        <Route path="/manage-spending/my-bills/add-billers" element={<AddBillers />} />
        <Route path="/manage-spending/my-bills/billers" element={<Billers />} />
        <Route path="/manage-spending/my-bills/calendar/all" element={<CalendarView />} />
        <Route path="/manage-spending/my-bills/calendar/annually" element={<CalendarView />} />
        <Route path="/manage-spending/my-bills/calendar/daily" element={<CalendarView />} />
        <Route path="/manage-spending/my-bills/calendar/fortnightly" element={<CalendarView />} />
        <Route path="/manage-spending/my-bills/calendar/monthly" element={<CalendarView />} />
        <Route path="/manage-spending/my-bills/calendar/quarterly" element={<CalendarView />} />
        <Route path="/manage-spending/my-bills/calendar/weekly-primary" element={<CalendarView />} />
        <Route path="/manage-spending/my-bills/calendar/weekly-secondary" element={<CalendarView />} />
        <Route path="/addbiller" element={<AddBillers />} />
        <Route path="/biller" element={<Billers />} />
        <Route path="/biller-calendarview" element={<CalendarView />} />

        {/* My Transaction */}
        <Route path="/my-transaction" element={<MyTransaction />} />
        <Route path="/my-transactions" element={<MyTransaction />} />
        <Route path="/my-transactions/details" element={<MyTransaction />} />

        {/* Pending Transactions */}
        <Route path="/pending-transactions" element={<PendingTransactions />} />

        {/* Reports */}
        <Route path="/reports" element={<Reports />} />

        {/*Budget */}
        <Route path="/budget-tracking" element={<BudgetTracker />} />
        <Route path="/budget-setup" element={<BudgetSetup />} />
        <Route path="/create-budget" element={<CreateBudget />} />

        {/* Retirement */}
        <Route path="/retirement-plan" element={<RetirementPlan />} />
        <Route path="/plan-for-retirement/overview" element={<RetirementPlan />} />

        {/* Save and Invest */}
        <Route path="/save&invest" element={<SaveAndInvest />} />
        <Route path="/save-and-invest/overview" element={<SaveAndInvest />} />

        {/* Credit */}
        <Route path="/credit" element={<Credit />} />
        <Route path="/credit/details" element={<Credit initialTab="Credit Details" />} />
        <Route path="/credit/report-overview" element={<Credit initialTab="Credit report Overview" />} />
        <Route path="/credit/factors-impacting-score" element={<Credit initialTab="Factors Impacting Score" />} />

        {/* Overview */}
        <Route path="/overview" element={<Overview />} />
        <Route path="/overview/finance" element={<Overview />} />
        <Route path="/overview/net-worth" element={<OverviewDetail />} />
        <Route path={`/overview-details`} element={<OverviewDetail />} />

        {/* Split Payment */}
        <Route path="/split-payment" element={<SplitPayment />} />
        <Route path="/split-payment/groups" element={<SplitPayment initialTab="All Groups" />} />
        <Route path="/split-payment/expenses" element={<SplitPayment initialTab="All Expenses" />} />
        <Route path="/split-payment/group-details" element={<SplitPayment initialTab="Expenses Details" />} />
        <Route path="/split-payment/group-balance-detail" element={<SplitPayment initialTab="Expenses Details" />} />
        <Route path="/split-payment/create-group" element={<CreateGroup />} />
        <Route path="/split-payment/add-expenses/equally" element={<AddExpenses />} />
        <Route path="/split-payment/add-expenses/unequally" element={<AddExpenses />} />
        <Route path="/split-payment/reminder" element={<Reminder />} />
        <Route path="/split-payment/settle-up" element={<SettleUp />} />
        <Route path="/split-payment/summary" element={<SplitSummary />} />
        <Route path="/split-payment/view-by-person" element={<ViewByPerson />} />
        <Route path="/reminder" element={<Reminder />} />
        <Route path="/settleup" element={<SettleUp />} />
        <Route path="/create-group" element={<CreateGroup />} />
        <Route path="/add-expenses" element={<AddExpenses />} />
        <Route path="/viewbyperson" element={<ViewByPerson />} />
        <Route path="/split-summary" element={<SplitSummary />} />

        {/* Admin Panel */}
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/transactions" element={<AdminTransactionHistory />} />
        {/* Payout partners, corridors and per-customer limits. Deliberately
            no block or KYC-approval action, both belong to WSO2. */}
        <Route path="/admin/settings" element={<AdminSettings />} />

        {/* Settings & Help */}
        <Route path="/settings" element={<Settings />} />
        <Route path="/help" element={<HelpCenter />} />

        {/* Native Figma flow screens for flows that are not first-class pages yet */}
        <Route path="/figma-screens" element={<FigmaScreensIndex />} />
        <Route path="/figma-screens/:slug" element={<FigmaScreenRoute />} />
        {FIGMA_FLOW_ROUTES.map(({ path, slug }) => (
          <Route
            key={`${path}-${slug}`}
            path={path}
            element={<FigmaScreenRoute screenSlug={slug} />}
          />
        ))}
      </Route>

      {/* Catch-all. Without this an unmatched path rendered a blank page with
          HTTP 200, which is indistinguishable from a broken app. */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
